import { Box, chakra } from '@chakra-ui/react'

export type RichTextProps = {
  html: string
  className?: string
}

/**
 * Represents a RichText component.
 * @param html - Incoming html content to render.
 * @param className - Optionally pass a classname for styling.
 * @returns RichText
 */
export default chakra(RichText)

function RichText({ html, className, ...props }: RichTextProps) {
  return (
    <Box
      dangerouslySetInnerHTML={{ __html: html }}
      className={className}
      {...props}
    />
  )
}
